// extracted by mini-css-extract-plugin
module.exports = {"debug":"styles_debug__3yKxs"};